import { isEmpty } from 'lodash';
import { array, bool, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { RadioGroup, Skeleton } from 'components';

const TravelLodgings = ({ lodgings, loading, lodgingError = '' }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white w-full h-auto rounded-xl mt-3 p-2 md:p-4">
      <h2 className="uppercase text-sm font-medium lg:h2 underlined-blue mb-4 lg:mb-8">
        {t('purchase:configuration.lodging')}
      </h2>

      {loading && (
        <>
          <Skeleton classNames="w-full h-12 mb-3" />
          <Skeleton classNames="w-full h-12" />
        </>
      )}

      {!loading && !isEmpty(lodgings) && (
        <form>
          <RadioGroup radioOptions={lodgings} labelHidden />
        </form>
      )}

      {!loading && lodgingError && <p className="my-2">{lodgingError}</p>}
    </div>
  );
};

TravelLodgings.propTypes = {
  lodgings: array,
  loading: bool,
  lodgingError: string
};

export default TravelLodgings;
